import { useTranslation } from "react-i18next";

import { HerbicideResistanceDetails } from "../components/marketing-layout/HerbicideResistanceDetails"
import { CallToAction } from "../components/marketing-layout/CallToAction";
import { MarketingLayout } from "../components/marketing-layout";

export const MarketingHerbicideResistance = () => {
	const { t } = useTranslation();
		
	return (
		<MarketingLayout>
			<>
				<CallToAction
					headingTitle={t("herbResist.ctaTitle")}
					headingDescription={t("herbResist.ctaDescription1")}
					headingDescription2={t("herbResist.ctaDescription2") || undefined}
					leftButtonLink="/contact-us"
					leftButtonText={t("herbResist.ctaLeftButton") || "Contact Us"}
					rightButtonLink="/contact-us"
					rightButtonText={t("herbResist.ctaRightButton") || "About Us"}
					ctaImageUrl="/new-better-photos/8700 Valmar 05.jpg"
					ctaImageAlt={t("herbResist.ctaImageAlt") || "Get Started Image"}
				/>
				<HerbicideResistanceDetails />
			</>
		</MarketingLayout>
	);
};
